module.exports = __webpack_public_path__ + "img/C2.54267375.svg";